module.exports = __webpack_public_path__ + "img/white-tag-20x20.177b71f3.svg";